import { Asset, ChatIcon, Button } from '@clearcover/atlas';
import React, { FC } from 'react';
import { reportEvent } from 'Shared/analytics';
import { useHelpdeskControls } from 'Shared/hooks';
import styles from './styles.module.css';

export const Helpdesk: FC<{
  appId: string;
  screen: string;
}> = ({ appId, screen }) => {
  const {
    loaded: isHelpdeskLoaded,
    isOpen,
    toggleOpen,
    eventName,
  } = useHelpdeskControls({
    zendeskVariant: 'quoteApp',
  });

  const handleClick = () => {
    if (!isOpen) {
      reportEvent(eventName, {
        appId,
        screen,
      });
    }
    toggleOpen();
  };

  return isHelpdeskLoaded ? (
    <Button
      data-testid="aqui-helpdesk"
      type="button"
      variant="primary"
      size="sm"
      title="Contact Helpdesk"
      className={styles.helpButton}
      onClick={handleClick}
    >
      <Asset
        icon={ChatIcon}
        height={24}
        width={24}
        description={'Help Icon'}
        className={styles.helpIcon}
      />
      Chat
    </Button>
  ) : null;
};
